import rules from "./common/rules";
import enumerate from "./common/enumerate";
const listToTree = function (list, id = 'id', parentId = 'parentId') {
    //不影响源数据
    let data = JSON.parse(JSON.stringify(list));
    // 生成parent建立父子关系
    const obj = {};
    data.forEach((item) => {
        obj[item[id]] = item;
    })
    const parentList = [];
    data.forEach((item) => {
        const parent = obj[item[parentId]];
        if (parent) {
            //  当前项有父节点
            parent.children = parent.children || [];
            parent.children.push(item);
        } else {
            //  当前项没有父节点 -> 顶层
            parentList.push(item);
        }
    });
    return parentList;
}
export default {
    // host: process.env.NODE_ENV === "development" ? "http://10.14.2.113:44002" : "http://localhost:10086",//http://39.99.246.110:10086 https://chaijie.zemichykj.com:10086/
    host: process.env.NODE_ENV === "development" ? "http://192.168.177.1:44322" : window.configs.host, //http://39.99.246.110:10086  //http://10.14.2.41:11187
    getToken: () => {
        return sessionStorage.getItem("token") || ''
    },
    ...rules,
    ...enumerate,
    listToTree
}